/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';


export const user = (state = defaultState.user, action) => {
    let nextState = Utilities.deepClone(state);

    switch (action.type) {
        case constants.USER_FETCH:
        case constants.USER_UPDATE:
            if (action.status == constants.STATE_SUCCESS) {
                 nextState.detail = action.payload;
            }
            break;

        case constants.USER_FETCH_PERMS:
            if (action.status == constants.STATE_SUCCESS) {
                nextState.perms = action.payload;
            }
            break;

        // Merged rather than assigned over `detail`: this is a periodic background
        // refresh of just the Intercom identity token, so everything else the
        // account fetch put in `detail` has to survive it.
        case constants.USER_INTERCOM_TOKEN:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.detail.intercomJwt = action.payload.intercomJwt;
                nextState.detail.intercomJwtTtl = action.payload.intercomJwtTtl;
            }
            break;

        case constants.SUB_CREATE:
        case constants.SUB_UPDATE:
        case constants.SUB_ADDON_UPDATE:
        case constants.USER_FETCH_PLAN:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.plan = action.payload;
            }
            break;

        case constants.USER_DELETE:
            if (action.status == constants.STATE_SUCCESS) {
                nextState.detail.wasDeleted = true;
            }
            break;

        case constants.USER_GENERATE_API_KEY:
            if (action.status == constants.STATE_SUCCESS) {
                nextState.detail.apiKeys = [action.payload];
            }
            break;

        case constants.DOMAIN_SET_DEFAULT:
            if (action.status == constants.STATE_SUCCESS) {
                nextState.detail.defaultPdId = 1;
                nextState.detail.defaultSaId = 0;
            }
            break;

        case constants.DOMAIN_UPDATE:
        case constants.DOMAIN_CREATE:
            if (action.status == constants.STATE_SUCCESS) {
                if (action.payload.default === 1) {
                    nextState.detail.defaultPdId = parseInt(action.payload.id, 10);
                    nextState.detail.defaultSaId = 0;
                }
            }
            break;

        // as the server does, the default going leaves No Shortener, or no domain, in its place
        case constants.SHORTENER_DELETE:
            if (action.status == constants.STATE_SUCCESS && parseInt(nextState.detail.defaultSaId, 10) === parseInt(action.payload.id, 10)) {
                nextState.detail.defaultSaId = 0;
            }
            break;

        case constants.DOMAIN_DELETE:
            if (action.status == constants.STATE_SUCCESS && parseInt(nextState.detail.defaultPdId, 10) === parseInt(action.payload.id, 10)) {
                nextState.detail.defaultPdId = 0;
            }
            break;

        case constants.SHORTENER_SET_DEFAULT:
            if (action.status == constants.STATE_SUCCESS) {
                nextState.detail.defaultSaId = parseInt(action.payload?.id ?? 0, 10);
                nextState.detail.defaultPdId = 0;
            }
            break;

        case constants.SHORTENER_UPDATE:
        case constants.SHORTENER_CREATE:
            if (action.status == constants.STATE_SUCCESS) {
                if (action.payload.default === 1) {
                    nextState.detail.defaultSaId = parseInt(action.payload.id, 10);
                    nextState.detail.defaultPdId = 0;
                }
            }
            break;

        default:
            break;
    }

    return nextState;

};
